import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IDtpSearch, IDtpDetail, IDtpInsert, IDtpUpdate } from "./dtpTypes";



class DtpService {
    async page(searchVo: IDtpSearch, config: object = {}) {
        const apiUrl = "/gtm/agreement/search/pg";
        return await httpRequest.post<IPage<IDtpDetail>>(apiUrl, searchVo, config);
    }
    async insert(insertVo: IDtpInsert) {
        const apiUrl = "/gtm/agreement/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async update(updateVo: IDtpUpdate) {
        const apiUrl = "/gtm/agreement/update";
        return await httpRequest.post<string>(apiUrl, updateVo);
    }
    async one(id: string) {
        const apiUrl = `/gtm/agreement/select/${id}`;
        return await httpRequest.get<IDtpDetail>(apiUrl);
    }
    //转报价合同
    async transferQuottion(id: string) {
        const apiUrl = ` /gtm/agreement/transfer/${id}`;
        return await httpRequest.get<IDtpDetail>(apiUrl);
    }
    //作废
    async disable(id: string) {
        const apiUrl = `/gtm/agreement/cancellation/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //列表导出
    async export(searchVo: IDtpSearch) {
        const appPageUrl = "/gtm/agreement/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }


    //询价单明细模板下载
    // async downloadTpl() {
    //     const appPageUrl = "/gtm/agreement/detail/downloadTpl";
    //     return await httpRequest.getFile(appPageUrl);
    // }



}

export const enquiryService = new DtpService();
